import { Pipe, PipeTransform } from '@angular/core';
import { InteractiveContentTranslateService } from './interactive-content-translate.service';

@Pipe({
  name: 'icTranslate',
  pure: true,
})
export class InteractiveContentTranslatePipe implements PipeTransform {
  constructor(
    private icTranslateService?: InteractiveContentTranslateService
  ) {}

  transform(label: string, labelAsString: string): string {
    return this.icTranslateService.instant(label, labelAsString);
  }
}
